(function ClientNewOrExisting($, Adzuki)
{
	"use strict";

	var ClientNewOrExisting = {};

	ClientNewOrExisting.toggleClientFields = function toggleClientFields($parent_div, count)
	{
		var $client_divs = $parent_div.find('.new-existing-client');

		$client_divs.each(function togg(i, obj) {
			var $self      = $(this),
			    view_count = (i + 1);

			if (view_count <= count) {
				ClientNewOrExisting.toggleDisabled($self, false);
				$self.removeClass('hidden');

			} else {
				ClientNewOrExisting.toggleDisabled($self, true);
				$self.addClass('hidden');
			}
		});
	};

	/**
	 * Intent is to disable or enable all inputs within the $parent so when posting the form, we only have to deal with the enabled fields
	 * @param jQuery Obj $parent   element surrounding client inputs
	 * @param boolean    disabled  true if you want the inputs disabled
	 */
	ClientNewOrExisting.toggleDisabled = function toggleDisabled($parent, disabled)
	{
		var $all_inputs = $parent.find(":input"),
		    $reset_con  = $parent.find(".reset-typeahead");

		$all_inputs.each(function togg(i, obj) {
			var $input = $(this);

			// if we are trying to enable fields, the input is an existing client typeahead and the user has already typed a name and clicked on a suggestion, which results
			// in the input being disabled unless the user then clicks on the "Reset" link, we do not want to enable the typeahead
			if ( (disabled === false) && ($input.is('.adzuki-typeahead.existing-client')) && (!$reset_con.hasClass('hidden')) ) {
				return;
			}

			$input.attr('disabled', disabled);
		});

		this.toggleOptIns($parent, disabled);
	};

	ClientNewOrExisting.toggleOptIns = function toggleOptIns($parent, parent_disabled)
	{
		var email      = $parent.find(".new-client-email").val(),
		    $opt_ins   = $parent.find(".opt-in");

		if ($opt_ins) {
			$opt_ins.each(function togg(i, obj) {
				var $opt_in = $(this);

				// if no email, we always want to un-check the opt-ins
				if (email.length < 1) {
					$opt_in.prop('checked', false);
				}

				// if parent element is disabled / hidden, we always want to disable the opt-ins regardless
				if (parent_disabled === true) {
					$opt_in.attr('disabled', true);
					return;
				}

				// parent is enabled below this line
				// if the email is not provided, disable the opt-ins
				if (email.length < 1) {
					$opt_in.attr('disabled', true);
					return;
				}

				// if the email is provided, enable the opt-ins
				$opt_in.attr('disabled', false);

				if ($opt_in.hasClass('weekly-travel-deals')) {
					// check "Opt In Weekly Travel Deals" by default if this is the first
					if (
						$(".weekly-travel-deals:first").attr('id') === $opt_in.attr('id')
						&& (
							!Adzuki.prod ||
							Adzuki.franchise_id !== '664'
						)
					) {
						$opt_in.prop('checked', true);
					}
				}
			});
		}
	};

	/**
	 * Since either an email or a phone is often required when adding a new client, we are going to adjust the required asterisks based on what the user has entered
	 *
	 * @param  jQuery Object $parent the element that contains the new client fields
	 */
	ClientNewOrExisting.toggleCustomRequireds = function toggleCustomRequireds($parent)
	{
		var $email_element  = $parent.find('.new-client-email'),
		    $phone_element  = $parent.find('.phone-number'),
		    $email_required = $email_element.closest('.form-group').find('.required'),
		    $phone_required = $phone_element.closest('.form-group').find('.required');

		if ((!$email_required) || (!$phone_required)) {
			return;
		}

		if ($email_element.val().length > 0) {
			$phone_required.addClass('hidden');
		} else {
			$phone_required.removeClass('hidden');
		}

		if ($phone_element.val().length > 0) {
			$email_required.addClass('hidden');
		} else {
			$email_required.removeClass('hidden');
		}
	};

	$(document).ready(function documentReady()
	{
		$('.prefix-type').change(function displayGenderByPrefix() {
			var prefix_value = $(this).val(),
				gender_field = $(this).parents('form').find('.gender-type');

			// This first condition applies only if the 'new-client-form' from the household section is being used,
			// since you can add multiple clients at once a different parent had be called.
			if (gender_field.length > 1) {
				gender_field = $(this).parents('.new-existing-client').find('.form-group .gender-type');
			}

			if (prefix_value === 'Mrs.' || prefix_value === 'Miss' || prefix_value === 'Ms.' ) {
				gender_field.val('1');
			} else if (prefix_value === 'Mr.') {
				gender_field.val('0');
			} else {
				gender_field.val('');
			}
		});

		$("#clientaddress-addresses-0-zip").keyup(function getZipUp() {
			$(this).val($(this).val().toUpperCase());
		});

		if ($(".adzuki-typeahead.existing-client").length > 0) {
			init_existing_client_typeahead();
		}

		if ($(".adzuki-typeahead.referred").length > 0) {
			Adzuki.Typeahead('.adzuki-typeahead.referred', '/Searches/clientNoEmail', function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
			});
		}

		/**
		 * Toggle new or existing form based on radio selection
		 */
		if ($("input:radio[class^=new-or-existing]").length > 0) {
			$("input:radio[class^=new-or-existing]").on('change', function tog() {
				var $self     = $(this),
				    iter      = $self.data('index'),
				    form_id   = $self.val() + '_client_form_' + iter,
				    parent_id = 'new_or_existing_client_' + iter;

				$("#" + parent_id + " .toggable").each(function togg(i, obj) {
					if (obj.id !== form_id) {
						$(obj).addClass('hidden');
					}
				});

				$('#' + form_id).removeClass('hidden');
			});
		}

		/**
		 * Toggle "Create New Source" vs "Select From Sources List"
		 */
		if ($(".source-input a").length > 0) {
			$(".source-input a").click(function toggleSource(e) {
				var $self          = $(this),
				    $parent        = $self.closest('.source-input-con'),
				    $source_inputs = $parent.find('.source-input');

				e.preventDefault();

				$source_inputs.each(function togg(i, obj) {
					var $element = $(obj),
					    $input   = $element.find(":input");
					$element.toggleClass('hidden');
					$input.val('');
				});
			});
		}

		if ($(".toggle-segments").length > 0) {
			$(".toggle-segments").click(function toggleSegments(e) {
				var $self        = $(this),
				    to_toggle    = $self.data('toggle');

				$('#' + to_toggle).toggleClass('hidden');
			});
		}

		// if a ClientNameTypeahead is pre-populated, toggle between a static client name element and the typeahead when edit icon clicked
		if ($(".pre-selected-client-typeahead").length > 0) {
			$(".pre-selected-client-typeahead a").click(function reset(e) {
				var $self            = $(this),
				    $parent          = $self.closest(".pre-selected-client-typeahead"),
				    $typeahead_div   = $parent.next(".existing-client-typeahead-field"),
				    $typeahead_input = $typeahead_div.find(".adzuki-typeahead");

				e.preventDefault();

				$parent.addClass('hidden');
				$typeahead_div.removeClass('hidden');
				$typeahead_input.focus();
				$typeahead_input.data('adzuki').reset();
			});
		}

		if ($('.new-client-email').length > 0) {
			// toggle the required asterisks for email and phone fields. One or the other is required usually
			$('.new-client-email').on('keyup', function click(e)
			{
				var $self   = $(this),
				    $parent = $self.closest('.new-client-fields');

				Adzuki.ClientNewOrExisting.toggleCustomRequireds($parent);
			});

			// toggle opt ins based on email address being changed
			$('.new-client-email').on('change', function click(e)
			{
				var $self   = $(this),
				    $parent = $self.closest('.new-client-fields');

				if ($parent) {
					// enable or disable opt-in checkboxes based on the email address field content
					Adzuki.ClientNewOrExisting.toggleOptIns($parent, false);
				}
			});
		}

		if ($('.phone-number').length > 0) {
			$('.phone-number').on('keyup', function click(e)
			{
				var $self   = $(this),
				    $parent = $self.closest('.new-client-fields');

				Adzuki.ClientNewOrExisting.toggleCustomRequireds($parent);
			});
		}
	});

	function init_existing_client_typeahead() {
		$(".adzuki-typeahead.existing-client").each(function existing_typeahead(i, obj) {
			var $obj        = $(obj),
			    exclude_ids = [];

			// if input has an attribute of data-exclusions, we are going to remove those client ids from the typeahead suggestions.  Multiple client ids
			// should be separated by a '|'
			if ($obj.attr('data-exclusions')) {
				exclude_ids = $obj.attr('data-exclusions').split('|');
			}

			Adzuki.Typeahead(
				$obj,
				'/Searches/client',
				function select(item, $self, typeahead) {
					getOptInOutStatus(item, i);
					typeahead.setHiddenValue(item.id);
				},
				null,
				function matcher(item) {
					var selected_client_ids;

					if ($($obj).data('include-selected')) {
						return item.id;
					}

					selected_client_ids = getClientsAlreadySelected();

					if ( (exclude_ids.indexOf(item.id) < 0) && (selected_client_ids.indexOf(item.id) < 0) ) {
						return item.id;
					}
				}
			);
		});
	}

	/**
	* Return the optIn status of a household existing client.
	*
	**/
	function getOptInOutStatus(item, i)
	{
		Adzuki.Ajax.get('/Households/getClientOptInStatus/' + item.id).then(function success(response) {
			if (response['weekly'].length > 0) {
				$('<small class = "weekly-opt" data-array = ' + i + '>' + response['weekly'] + "</small>").appendTo('#household-client-' + i + ' .existing_opted_in .form-control-static');
			}
			if (response['luxury'].length > 0) {
				$('<small class = "luxury-opt" data-array = ' + i + '>' + response['luxury'] + "</small>").appendTo('#household-client-' + i + ' .existing_luxury_opted_in .form-control-static');
			}

		});
	}
	/**
	 * Return an array of all of the existing clients that have already been typed ahead and were selected. Need this in order to remove them from other
	 * client typeaheads on the same page.
	 *
	 * @return array all typeahead client_ids that have already been selected on the current page.  If they get reset, they won't be found here anymore, which is good.
	 */
	function getClientsAlreadySelected()
	{
		var already_selected = [];

		// find any already selected client ids
		$(".existing-client-hidden-id").each(function eachHidden(i, obj) {
			var $hidden = $(obj);

			if ($hidden.val()) {
				already_selected.push($hidden.val());
			}
		});

		return already_selected;
	}

	Adzuki.ClientNewOrExisting = ClientNewOrExisting;

}(jQuery, window.Adzuki || {}));
